export class TimelineRequestDTO {
  TargetUserId: string;
  ViewingUserId: string;
  GoalPeriodId: string;
  ForceRefresh: boolean;
  MaxItemsPerCategory: number;
  IsTeamData: boolean;
  CountOverDueOnly: boolean;
  RelyingPartyKey: string;
  IsCareerData: boolean;
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/timeline/timeline-request.dto.ts